/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
const bearerToken = '3c007be61d17302fd4e49ff26e2ed471f844dab4';
export default bearerToken;
